/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown>, table: NonNullable<unknown>, dataset: NonNullable<unknown> }} Agent_Wizard_Card_Action_TargetInputs */



/**
* | output |
* | --- |
* | "{action}: {table} in {dataset}" |
*
* @param {Agent_Wizard_Card_Action_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_card_action_target = /** @type {((inputs: Agent_Wizard_Card_Action_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Card_Action_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.action}: ${i?.table} in ${i?.dataset}`)
	return /** @type {LocalizedString} */ (`${i?.action}: ${i?.table} in ${i?.dataset}`)
});